import { jsxs as C, Fragment as s, jsx as o } from "react/jsx-runtime";
import { useState as V, useEffect as b } from "react";
import { useBreakpoint as u, Tabs as m, TabDesign as k } from "@nextgen-web-framework/all";
import v from "../ShopByBrands/ShopByBrands.js";
import y from "../ImagesAndLinksContainer/ImagesAndLinksContainer.js";
import '../../assets/ShopByContainer.css';const T = "#ffffff", _ = "#396e75", B = "#e5fdff", w = "#546223", p = "#f0fae5", G = "#a65523", O = "#fff1e8", R = "#7f3e3e", S = "#ffe2e2", W = "#62625a", A = "#f8f8e7", L = "#38539a", N = "#707070", P = "#c8f8d1", Y = "#87c9c8", I = "#5291b1", j = "rgba(82, 145, 177, 0.1019607843)", x = "#445685", $ = "#181d61", D = "rgba(24, 29, 97, 0.1019607843)", E = "#5969d6", F = "#ea999d", q = "#b6577e", H = "rgba(182, 87, 126, 0.1019607843)", J = "#7e3e80", K = "#1e247f", M = "rgba(30, 36, 127, 0.1019607843)", Q = "#da7600", U = "#107f47", X = "#d91734", Z = "_html_l3wne_38", r = {
  amwayWhite: T,
  darkBlue: _,
  lightBlue: B,
  darkGreen: w,
  lightGreen: p,
  darkOrange: G,
  lightOrange: O,
  darkRed: R,
  lightRed: S,
  darkYellow: W,
  lightYellow: A,
  darkPurple: L,
  darkGrayOnWhite: N,
  dataVizColor1: P,
  dataVizColor2: Y,
  dataVizColor3: I,
  dataVizColor3Background: j,
  dataVizColor4: x,
  dataVizColor5: $,
  dataVizColor5Background: D,
  dataVizColor6: E,
  dataVizColor7: F,
  dataVizColor8: q,
  dataVizColor8Background: H,
  dataVizColor9: J,
  dataVizColor10: K,
  dataVizColor10Background: M,
  dataVizAlertOrange: Q,
  dataVizSuccessGreen: U,
  dataVizWarningRed: X,
  "no-visible": "_no-visible_l3wne_34",
  html: Z,
  "shop-by-page-navigator": "_shop-by-page-navigator_l3wne_72",
  "shop-by-navigator-container": "_shop-by-navigator-container_l3wne_77",
  "shop-by-page-container": "_shop-by-page-container_l3wne_92"
}, ia = (t) => {
  var l;
  const [g, i] = V(t.activeTab), h = u(), n = (l = t.navigations) == null ? void 0 : l.filter((a) => {
    var e;
    return ((e = a.viewport) == null ? void 0 : e.includes(h)) ?? !0;
  }).map((a) => ({
    title: a.title,
    id: a.menuId
  }));
  b(() => {
    var a;
    t.activeTab ? i(t.activeTab) : n.length && i((a = n[0]) == null ? void 0 : a.id);
  }, [t.activeTab]);
  const f = () => {
    const a = t.navigations.find((e) => g === e.menuId ? e : null);
    switch (a == null ? void 0 : a.menuType) {
      case "images_only":
        return /* @__PURE__ */ o(v, { categories: a.categories, allTitle: a.allTitle });
      case "images_and_links":
        return /* @__PURE__ */ o(y, { categories: a.categories, allTitle: a.allTitle });
      default:
        return /* @__PURE__ */ o(s, {});
    }
  }, z = (a) => {
    var e, d, c;
    i((e = n[a]) == null ? void 0 : e.id), (c = t.onTabClick) == null || c.call(t, (d = n[a]) == null ? void 0 : d.id);
  };
  return /* @__PURE__ */ C(s, { children: [
    /* @__PURE__ */ o(
      "div",
      {
        className: `${r["shop-by-page-navigator"]} shop-by-navigator-positions hide-scrollbar`,
        "data-testid": "shop-by-page-container-testid",
        "data-pod-name": "commerce",
        children: !t.hideNavigation && n.length > 0 && /* @__PURE__ */ o("div", { className: `${r["shop-by-navigator-container"]}`, children: /* @__PURE__ */ o(
          m,
          {
            design: k.PILL,
            onTabClick: (a) => z(a),
            selectedTab: t.selectedTab,
            tabList: n
          }
        ) })
      }
    ),
    /* @__PURE__ */ o("div", { className: r["shop-by-page-container"], children: f() })
  ] });
};
export {
  ia as default
};
//# sourceMappingURL=ShopByContainer.js.map
